import React from 'react';
import cx from 'classnames';
import { Container } from './styles';
const sizes = {
    lg: 64,
    md: 32,
};
const getSize = (type = 'md') => {
    return sizes[type] || sizes.md;
};
export const Avatar = (props) => {
    const size = getSize(props.type);
    return (React.createElement(Container, { className: cx('avatar', props.className), style: props.style, type: props.type, size: size, "data-role": "avatar" },
        React.createElement("img", { className: "avatar-image", "data-role": "avatar-image", src: props.src })));
};
